import React, { useState } from 'react';
import './escapedpage.css';

import escapeVideo from '../assets/PixVerse_V6_Image_Text_360P_animate_it_like_we.mp4';
import Won from '../components/common/won';

const Escapedpage = () => {
  const [showWin, setShowWin] = useState(false);

  return (
    <div className="escapevideo">

      <video
        className="video"
        src={escapeVideo}
        autoPlay
        muted
        playsInline
        onEnded={() => setShowWin(true)}
      />

      {showWin && (
        <Won onReplay={() => window.location.reload()} 
         chooseRoomPath="/levels2"/>
        
      )}

    </div>
  );
};

export default Escapedpage;